import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type HeaderVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type HeadingAlign = 'left' | 'center' | 'right';

const HeaderAligns: Record<HeadingAlign, string> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

type HeaderProps = PropsWithChildren<{
  variant?: HeaderVariant;
  align?: 'left' | 'center' | 'right';
}> &
  React.ComponentProps<'h1'>;

export const Heading = ({
  variant = 'h1',
  align = 'center',
  children,
  ...props
}: HeaderProps): JSX.Element => {
  const defaultClasses = 'antialiased';
  let classNames = twMerge(defaultClasses, props.className);

  if (align) {
    classNames = twMerge(HeaderAligns[align], classNames);
  }

  if (variant === 'h6') {
    return <h6 className={twMerge('font-aribau', classNames)}>{children}</h6>;
  }
  if (variant === 'h5') {
    return <h5 className={twMerge('font-aribau', classNames)}>{children}</h5>;
  }
  if (variant === 'h4') {
    return <h4 className={twMerge('font-aribaubold text-xl', classNames)}>{children}</h4>;
  }
  if (variant === 'h3') {
    return <h3 className={twMerge('font-aribaubold text-3xl', classNames)}>{children}</h3>;
  }
  if (variant === 'h2') {
    return <h2 className={twMerge('font-ramillas text-4xl', classNames)}>{children}</h2>;
  }

  return <h1 className={twMerge('font-ramillas text-5xl', classNames)}>{children}</h1>;
};
